import React, { memo } from 'react'
import { SocialUrl } from '~api'
import * as Styled from './DetailsOverview.styles'
import SocialLinks from '../SocialLinks'

interface Props {
  description: string
  socialUrls: SocialUrl[]
}

const DetailsOverview: React.FC<Props> = memo(({ description, socialUrls }) => (
  <Styled.Container>
    <Styled.Description>{description || 'No description yet'}</Styled.Description>

    {!!socialUrls.length && (
      <Styled.SocialContainer>
        <SocialLinks socialUrls={socialUrls} />
      </Styled.SocialContainer>
    )}
  </Styled.Container>
))

DetailsOverview.displayName = 'DetailsOverview'
export default DetailsOverview
